module.exports = __webpack_public_path__ + "img/jcb.d09b230c.png";